export const NO_PLAYER_FOUND_TIMEOUT = 90000; // in ms

export const TIME_BEFORE_SHOW_TIMER_IN_MODALS = 120000; // in ms

export const SHOW_REVEAL_BTN = 120000; // in ms

export const TIME_FOR_TRANSACTION_MINTING = 60000; // in ms ONE MINUTE
